import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'

import {
  MOUNT,
  UNMOUNT,
  SUBMIT
} from './constants'

import {
  updateActive,
  updateFileId,
  updateName,
  unmount as closeDialog
} from './actions'

import {
  patchFileDescription,
} from 'containers/Project/FileSection/actions'

import {
  fileSelector,
  idSelector,
  nameSelector,
} from './selectors'

function* clear() {
  yield put(updateFileId(null))
  yield put(updateActive(false))
  yield put(updateName(''))
}

function* handleMount(action) {
  const { id } = action
  yield put(updateFileId(id))
  const { description } = yield select(fileSelector)
  yield put(updateName(description))
  yield put(updateActive(true))
}

function* handleUnmount(action) {
  yield fork(clear)
}

function* handleSubmit() {
  const name = yield select(nameSelector)
  const id = yield select(idSelector)
  yield put(patchFileDescription(id, name))
  yield put(closeDialog())
}

function* mount() {
  yield takeEvery(MOUNT, handleMount)
}

function* unmount() {
  yield takeEvery(UNMOUNT, handleUnmount)
}

function* watchSubmit() {
  yield takeEvery(SUBMIT, handleSubmit)
}

function* loadSagas() {
  yield all([
    fork(mount),
    fork(unmount),
    fork(watchSubmit)
  ])
}

export default loadSagas
